export default {
  baseStyle: {
    fontFamily: "Quicksand, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    letterSpacing: 0.5,
    lineHeight: "16px",
    textTransform: "uppercase",
    borderRadius: "999px",
    minW: "150px",
    minWidth: "150px",
    py: 6,
  },
  variants: {
    primary: {
      color: "textLight",
      bgColor: "primary",
    },
    accent1: {
      color: "textDark",
      bgColor: "accent1",
    },
    accent2: {
      color: "textLight",
      bgColor: "accent2",
    },
  },
  sizes: {},
  defaultProps: {
    variant: "primary",
  },
}
